export default "__VITE_ASSET__BDARWk21__"